import { gql } from '@apollo/client';

const CREATE_COURSE = gql`
    mutation createCourse( $input: CourseInput! ) {
        result: createCourse( input: $input ) {
            id
            locales {
                locale
                name
                description
            }
            isIlt
            thumbnailImage {
                id
                name
                url
                __typename
            }
            heroImage {
                id
                name
                url
                __typename
            }
            points
            isPublic
            enrollmentCount
            learningObjects {
                edges {
                    assignment {
                        status
                        scormState
                        __typename
                    }
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        duration
                        content {
                            id
                            url
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                __typename
            }
            tagIds
            categoryIds
            segmentIds
            brandIds
            localeIds
            companyRelationshipIds
            metadata
            createdAt
            updatedAt
        }
    }
`;

export default CREATE_COURSE;
